<template>
<div>
    <Birthday />
    <div v-if="usuario.id_group == 1" style="width: 100%!important;">
        <admin />
    </div>
    <template v-if="usuario.id_group == 6">
        <docente />
    </template>
    <template v-if="usuario.id_group == 4">
        <estudianteVue />
    </template>
    <!--MODAL PARA CAMBIAR DE PASSWORD-->
    <vs-popup class="holamundo" title="Actualización de contraseña" :active.sync="popupChangePassword" @close="handleClose" :class="{ 'hide-close': !showCloseButton }">
        <popupChangePasswordVue v-if="popupChangePassword" @changeRecarge="changeRecarge" />
    </vs-popup>
</div>
</template>

<script>
import Birthday from "./birthday/birthday.vue"
import popupChangePasswordVue from './home/components/todos/popupChangePassword.vue'
import Vue from 'vue'
import axios from 'axios'
import admin from './perfiles/admin.vue'
import docente from './perfiles/docente.vue'
import estudianteVue from './perfiles/estudiante.vue'
import moment from 'moment'
Vue.use(axios)
export default {
    components: {
        admin,
        docente,
        estudianteVue,
        popupChangePasswordVue,
        Birthday,
    },
    data() {
        return {
            usuario: [],
            //variables para change password
            popupChangePassword: false,
            showCloseButton: false,
            //fin variables para change password
        }
    },
    created() {
        this.usuario = JSON.parse(localStorage.getItem('usuario'))[0];
    },
    mounted() {
        let me = this;
        me.getPeriodoInstitucion();
        //change password
        me.changePassword()
    },
    methods: {
        //para obtener el perido atual
        getPeriodoInstitucion() {
            let me = this;
            this.$http.get(this.$server_url + 'institucionTraerPeriodo?institucion_id=' + me.usuario.institucion_idInstitucion)
                .then(function (res) {
                    localStorage.setItem('periodo_id', res.data[0].periodo)
                    localStorage.setItem('descripcion_periodo', res.data[0].descripcion)
                    localStorage.setItem('nombreInstitucion', res.data[0].nombreInstitucion)
                    localStorage.setItem('region', res.data[0].region)
                })
                .catch(function (error) {
                    console.log(error + ' error');
                })
        },
        handleClose() {
            let me = this;
            me.popupChangePassword = true
        },
        changeRecarge(e) {
            let me = this;
            me.popupChangePassword = false
        },
        //METODOS PARA CAMBIAR PASSWORD 
        changePassword() {
            let me = this;
            //excepto los estudiantes
            if (me.usuario.id_group == 4) {
                return
            } else {
                var fecha30dias = me.usuario.fecha_change_password
                var validateF = me.esFechaValida(fecha30dias)
                var fechaActual = moment().format('YYYY-MM-DD')
                if (validateF) {
                    //validar si existe la fecha despues de 30 dias
                    if ((fecha30dias <= fechaActual)) {
                        me.popupChangePassword = true
                    }
                    return
                }
                //si no tiene fecha de recordario
                if (me.usuario.change_password == 1) {
                    me.popupChangePassword = true
                }
            }
        },
        esFechaValida(fecha) {
            if (fecha == null || fecha == "null" || fecha == "") {
                return false
            }
            var dateObj = new Date(fecha);
            return !isNaN(dateObj);
        },
        //FIN METODOS PARA CAMBIAR PASSWORD
    },
}
</script>

<style lang="scss">
.hide-close hide-close .vs-popup--close {
    display: none;
}
</style>
